module.exports = __webpack_public_path__ + "static/persona1-0f644c47fd2d73e5dcacf91c9b662821.png";